var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-12 flex flex-row"},[_c('label',{staticClass:"text-2xl text-left",staticStyle:{"width":"400px"}},[_vm._v("회수 완료")]),_c('v-chart',{staticClass:"chart bg-white",staticStyle:{"height":"400px","width":"400px"},attrs:{"option":_vm.pieChart}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }